import { render, staticRenderFns } from "./InsightChartDonut.vue?vue&type=template&id=868320ae"
import script from "./InsightChartDonut.vue?vue&type=script&lang=js"
export * from "./InsightChartDonut.vue?vue&type=script&lang=js"
import style0 from "./InsightChartDonut.vue?vue&type=style&index=0&id=868320ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports